"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SEARCH_SUGGESTIONS = "\n  query Search($term: String!) {\n    search(term: $term) {\n        results {\n            __typename\n            ... on Title {\n              id\n              title\n            }\n        }\n    }\n}";
exports.default = SEARCH_SUGGESTIONS;
//# sourceMappingURL=suggestions.js.map